import * as ambassadorWixQuickpagesV1PublishedPage from './quickpages-v1-published-page-published-pages.http.js';
import * as ambassadorWixQuickpagesV1PublishedPageTypes from './quickpages-v1-published-page-published-pages.types.js';
import * as ambassadorWixQuickpagesV1PublishedPageUniversalTypes from './quickpages-v1-published-page-published-pages.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getPublishedPage(): __PublicMethodMetaInfo<
  'GET',
  { publishedPageId: string },
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.GetPublishedPageRequest,
  ambassadorWixQuickpagesV1PublishedPageTypes.GetPublishedPageRequest,
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.GetPublishedPageResponse,
  ambassadorWixQuickpagesV1PublishedPageTypes.GetPublishedPageResponse
> {
  const payload = { publishedPageId: ':publishedPageId' } as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1PublishedPage.getPublishedPage(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/published-pages/{publishedPageId}',
    pathParams: { publishedPageId: 'publishedPageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPublishedPageBySlug(): __PublicMethodMetaInfo<
  'GET',
  { slug: string },
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.GetPublishedPageBySlugRequest,
  ambassadorWixQuickpagesV1PublishedPageTypes.GetPublishedPageBySlugRequest,
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.GetPublishedPageBySlugResponse,
  ambassadorWixQuickpagesV1PublishedPageTypes.GetPublishedPageBySlugResponse
> {
  const payload = { slug: ':slug' } as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1PublishedPage.getPublishedPageBySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/published-pages/{slug}/slug',
    pathParams: { slug: 'slug' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPublishedPageByPageId(): __PublicMethodMetaInfo<
  'GET',
  { pageId: string },
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.GetPublishedPageByPageIdRequest,
  ambassadorWixQuickpagesV1PublishedPageTypes.GetPublishedPageByPageIdRequest,
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.GetPublishedPageByPageIdResponse,
  ambassadorWixQuickpagesV1PublishedPageTypes.GetPublishedPageByPageIdResponse
> {
  const payload = { pageId: ':pageId' } as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1PublishedPage.getPublishedPageByPageId(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/published-pages/{pageId}/page-id',
    pathParams: { pageId: 'pageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPublishedPages(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.QueryPublishedPagesRequest,
  ambassadorWixQuickpagesV1PublishedPageTypes.QueryPublishedPagesRequest,
  ambassadorWixQuickpagesV1PublishedPageUniversalTypes.QueryPublishedPagesResponse,
  ambassadorWixQuickpagesV1PublishedPageTypes.QueryPublishedPagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixQuickpagesV1PublishedPage.queryPublishedPages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/published-pages/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PublishedPage as PublishedPageOriginal,
  GetPublishedPageRequest as GetPublishedPageRequestOriginal,
  GetPublishedPageResponse as GetPublishedPageResponseOriginal,
  GetPublishedPageBySlugRequest as GetPublishedPageBySlugRequestOriginal,
  GetPublishedPageBySlugResponse as GetPublishedPageBySlugResponseOriginal,
  GetPublishedPageByPageIdRequest as GetPublishedPageByPageIdRequestOriginal,
  GetPublishedPageByPageIdResponse as GetPublishedPageByPageIdResponseOriginal,
  QueryPublishedPagesRequest as QueryPublishedPagesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPublishedPagesResponse as QueryPublishedPagesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './quickpages-v1-published-page-published-pages.types.js';
